
import { mapGetters } from 'vuex'
export default {
  props: {
    productCart: {
      type: Array,
      default: () => [],
    },
    actionFinishPayment: {
      type: Function,
      default: () => {},
    },
    actionVolta: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('cart', ['totalCartPrice', 'discountPrice']),
  },
}
